import { CommonEnums } from '../../common.enums';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { RepConn } from '../datapoint/repconn';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { TCmd_Inst } from '../tcmd_Inst'
import { Flagent } from '../datapoint/flagent';
import { DxFlow_Obj_PropertiesUtil } from '../../utils/dxflow_obj_properties.util';
import { Flagent_Grp } from '../datapoint/flagent_grp';

export class TaskCommand {
    tCmd_Inst: TCmd_Inst;
    fldr_Id: number;
    flagent: Flagent;
    flagent_Grp: Flagent_Grp
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    repConn: RepConn;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.tCmd_Inst = new TCmd_Inst();
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.flagent = new Flagent();
        this.flagent_Grp = new Flagent_Grp();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.repConn = new RepConn();
    }

    static parse(taskCommandTmp: TaskCommand): TaskCommand {
        let taskcommand = new TaskCommand();
        taskcommand.copyFrom(taskCommandTmp as TaskCommand)
        return taskcommand;
    }

    copy(): TaskCommand {
        let taskCommandTmp: TaskCommand = new TaskCommand();
        taskCommandTmp.tCmd_Inst = this.tCmd_Inst.copy();
        taskCommandTmp.fldr_Id = this.fldr_Id;
        taskCommandTmp.flagent = this.flagent.copy();
        taskCommandTmp.flagent_Grp = this.flagent_Grp.copy();
        taskCommandTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        taskCommandTmp.conn_Db_Obj_Lnk = this.conn_Db_Obj_Lnk.copy();
        taskCommandTmp.change_Ind = this.change_Ind;
        taskCommandTmp.error_Cd = this.error_Cd;
        taskCommandTmp.error_Msg = this.error_Msg;
        taskCommandTmp.ref_Id = this.ref_Id;
        taskCommandTmp.ref_Cd = this.ref_Cd;

        if (this.repConn)
            taskCommandTmp.repConn = this.repConn.copy();

        return taskCommandTmp;
    }

    copyFrom(taskCommandTmp: TaskCommand): void {
        this.tCmd_Inst.copyFrom(taskCommandTmp.tCmd_Inst);
        this.fldr_Id = taskCommandTmp.fldr_Id;
        this.flagent.copyFrom(taskCommandTmp.flagent);
        this.flagent_Grp.copyFrom(taskCommandTmp.flagent_Grp);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, taskCommandTmp.dxFlow_Obj_Properties);
        this.conn_Db_Obj_Lnk.copyFrom(taskCommandTmp.conn_Db_Obj_Lnk);
        this.change_Ind = taskCommandTmp.change_Ind;
        this.error_Cd = taskCommandTmp.error_Cd;
        this.ref_Cd = taskCommandTmp.ref_Cd;
        this.ref_Id = taskCommandTmp.ref_Id;
        this.error_Msg = taskCommandTmp.error_Msg;

        if (taskCommandTmp.repConn)
            this.repConn.copyFrom(taskCommandTmp.repConn);
    }

    compare(taskCommandTmp: TaskCommand): string {
        let diffString = '';
        diffString = this.tCmd_Inst.compare(taskCommandTmp.tCmd_Inst)
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, taskCommandTmp.dxFlow_Obj_Properties)
        if (diffString != '') return diffString;

        if (this.conn_Db_Obj_Lnk.toString() != (taskCommandTmp.conn_Db_Obj_Lnk).toString())
            return 'diff';

        return diffString;
    }

    toString(): string {
        return "TaskCommand [fldr_Id=" + this.fldr_Id +
            ", flagent=" + this.flagent.toString() +
            ", flagent=" + this.flagent_Grp.toString() +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", conn_Db_Obj_Lnk=" + this.conn_Db_Obj_Lnk.toString() +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Cd=" + this.ref_Cd +
            ", ref_Id=" + this.ref_Id +
            ", repConn=" + this.repConn.toString() + "]"
    }
}
